import { h } from 'preact'

export default props => 
    <button {...props} class={"limba__edit-button " + (props.class || '')} ><span class="konf-icon-Pencil"></span></button>


// WEBPACK FOOTER //
// ./js/components/EditButton.js